import { defaultDateDef, defaultNumberDef } from '@components/_SiteWide/CellTemplates/typeColumnDefs'
import { addCommasToNumber } from '@gravitate-js/excalibrr'
import { ModelGridActionButtons } from './components/ActionButtons'
import { StatusRenderer } from './components/StatusRenderer'

export const getColumnDefs = () => [
  {
    headerName: 'Time',
    field: 'time_ran',
    ...defaultDateDef('time_ran'),
    minWidth: 150,
  },
  {
    headerName: 'Period Count',
    field: 'period_count',
    ...defaultNumberDef('period_count', 0),
    minWidth: 60,
  },
  {
    headerName: 'Markets',
    field: 'markets',
    minWidth: 150,
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: StatusRenderer,
    minWidth: 120,
  },
  {
    headerName: 'Final Min Gap',
    filter: 'agNumberColumnFilter',
    field: 'final_mip_gap',
    type: 'rightAligned',
    valueGetter: ({ data }) => data && data.final_mip_gap * 100,
    valueFormatter: ({ value }) => value && `${addCommasToNumber(value, 2)}%`,
    minWidth: 80,
  },
  { field: 'number_of_orders', headerName: 'No. of Orders', ...defaultNumberDef('number_of_orders', 0) },

  {
    field: 'resume_date',
    ...defaultDateDef('resume_date'),
    headerName: 'Resume Date',
    minWidth: 120,
  },
  {
    headerName: 'Actions',
    field: 'has_excel',
    cellRenderer: ModelGridActionButtons,
    minWidth: 265,
    filter: false,
    pinned: 'right',
  },
]
